{
  "version": 1,
  "asset_id": "62ec4345-5a63-4b8c-8fdb-713e4a3943b4",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/62ec4345-5a63-4b8c-8fdb-713e4a3943b4/raindrop-maple-seeds.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/62ec4345-5a63-4b8c-8fdb-713e4a3943b4/raindrop-maple-seeds.mp4",
  "original_filename": "raindrop-maple-seeds.mp4",
  "size": 6308491,
  "content_type": "video/mp4",
  "created_at": "2026-08-15T17:14:22Z"
}
